import { useEffect } from "react";
import "./styles/shell.css";
import "./styles/settings.css";
import { AppProvider, useApp } from "./state/AppContext";
import { SignIn } from "./components/SignIn";
import { Shell } from "./components/Shell";

function Root() {
  const { status, me } = useApp();

  useEffect(() => {
    document.documentElement.setAttribute("data-gm-theme", me?.prefs.theme ?? "graphite");
  }, [me?.prefs.theme]);

  if (status === "loading") return null;
  if (status === "signed_out") return <SignIn />;
  return <Shell />;
}

export default function App() {
  return (
    <AppProvider>
      <Root />
    </AppProvider>
  );
}
